/**
 * Validates that a URL is a legitimate Google Business Profile URL
 * to prevent open redirect attacks.
 */
export function isValidGoogleUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  
  try {
    const parsed = new URL(url);
    
    // Allowed base domains for Google Business Profile URLs
    // This includes all regional Google domains and Google short URL services
    const allowedDomains = [
      // Main Google domains
      'google.com',
      'google.co.in',
      'google.co.uk',
      'google.ca',
      'google.com.au',
      'google.de',
      'google.fr',
      'google.es',
      'google.it',
      'google.co.jp',
      'google.com.br',
      // Google short URL and sharing domains
      'g.page',
      'g.co',
      'goo.gl',
      // Google sharing domain (used for some business profile links)
      'share.google',
    ];
    
    // Check if hostname matches any allowed domain (including subdomains like www, maps, business, etc.)
    return allowedDomains.some(domain => 
      parsed.hostname === domain || 
      parsed.hostname.endsWith('.' + domain)
    );
  } catch {
    return false;
  }
}

/**
 * Returns the URL if valid, otherwise returns a safe fallback
 */
export function getSafeGoogleUrl(url: string | null | undefined, fallback: string = 'https://business.google.com'): string {
  return isValidGoogleUrl(url) ? url! : fallback;
}
